@if (store.isOpen() && store.isMobile()) {
  <div
    #overlay
    class="search-mobile"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'explore.bottom-bar.search' | i18next"
    (keydown.escape)="store.dismiss()"
    (touchmove)="onTouchMove($event)"
    (touchend)="closeKeyboardOutsideBar($event)">
    <form
      #bar
      class="search-mobile__bar"
      role="search"
      method="get"
      [action]="'search-results' | routeTranslate"
      (submit)="onSubmit($event)">
      <button
        type="button"
        mat-icon-button
        color="secondary"
        class="search-mobile__back sharry-medium"
        [attr.aria-label]="'close' | i18next"
        (click)="store.dismiss()">
        <sharry-icon name="caret-left"></sharry-icon>
      </button>
      <label
        class="cdk-visually-hidden"
        [for]="inputId"
        >{{ 'explore.bottom-bar.search' | i18next }}</label
      >
      <input
        #input
        class="search-mobile__input"
        name="value"
        [id]="inputId"
        [sharrySearchInput]="listboxId"
        [placeholder]="'search-bar.placeholder' | i18next" />
      <input
        type="hidden"
        name="prefix"
        value="title" />
      @if (store.query()) {
        <button
          type="button"
          mat-icon-button
          color="secondary"
          class="search-mobile__clear sharry-small"
          [attr.aria-label]="'search-bar.clear' | i18next"
          (click)="clear()">
          <sharry-icon name="x"></sharry-icon>
        </button>
      }
      <button
        type="submit"
        mat-flat-button
        color="primary-rainbow"
        class="search-mobile__submit"
        [class.search-mobile__submit--idle]="!store.canSubmit()"
        [attr.aria-label]="'explore.bottom-bar.search' | i18next">
        <sharry-icon name="magnifying-glass"></sharry-icon>
      </button>
    </form>

    <div
      #body
      class="search-mobile__body"
      (touchstart)="keepBodyScrollable()">
      <button
        type="button"
        class="search-mobile__near"
        (click)="store.searchNearMe()">
        <span
          class="search-mobile__near-icon"
          aria-hidden="true"></span>
        {{ 'prefix-search.location' | i18next }}
      </button>

      @if (store.hasTerm()) {
        <sharry-search-results [listboxId]="listboxId"></sharry-search-results>
        @if (store.noResults()) {
          <sharry-search-suggestions></sharry-search-suggestions>
        }
      } @else {
        <sharry-search-suggestions></sharry-search-suggestions>
      }
    </div>
  </div>
}
